export default "__VITE_ASSET__wwTXiejc__"